module.exports = __webpack_public_path__ + "media/images/orabank-3185c098641ea15941d99ceb9aeb263d.jpg";